"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mirandola": {
    "f5491cfc": [{
      "hkey": "08c25d66",
      "slug": "mirandola",
      "name": "Mirandola",
      "primary": true,
      "skipSearch": false
    }],
    "confine": [{
      "hkey": "08c25d66",
      "slug": "mirandola",
      "name": "Mirandola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0ddf4beb": [{
      "hkey": "46457178",
      "slug": "mortizzuolo-ponte-san-pellegrino",
      "name": "Mortizzuolo-Ponte San Pellegrino",
      "primary": true,
      "skipSearch": false
    }],
    "mortizzuolo": [{
      "hkey": "46457178",
      "slug": "mortizzuolo-ponte-san-pellegrino",
      "name": "Mortizzuolo-Ponte San Pellegrino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7a20e546": [{
      "hkey": "08c25d66",
      "slug": "mirandola",
      "name": "Mirandola",
      "primary": true,
      "skipSearch": false
    }],
    "santa-giustina-vigona": [{
      "hkey": "08c25d66",
      "slug": "mirandola",
      "name": "Mirandola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;